module.exports = __webpack_public_path__ + "static/media/list_active.9ee7e859.svg";